import { render } from "./MobileBusinessCard.vue?vue&type=template&id=3d482a18&scoped=true&ts=true"
import script from "./MobileBusinessCard.vue?vue&type=script&lang=ts"
export * from "./MobileBusinessCard.vue?vue&type=script&lang=ts"

import "./MobileBusinessCard.vue?vue&type=style&index=0&id=3d482a18&scoped=true&lang=less"

import exportComponent from "D:\\sunrun_luo\\JK-neibu\\JKai-zhuzhan\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d482a18"]])

export default __exports__